// apps/web/src/features/calendar/ics/filterDeadlines.ts

import type { AppEvent } from "../types";

function s(x: any) {
  return (x ?? "").toString().toLowerCase();
}

/**
 * Moodle обычно помечает дедлайны словами:
 * - due / deadline
 * - assignment
 * - quiz
 * - workshop
 * - turnitin
 * + в description часто есть "Due date"
 */
export function keepOnlyDeadlines(events: AppEvent[]) {
  return events.filter((e) => {
    if (e.kind === "deadline" || e.kind === "assignment") return true;
    if (e.kind === "lesson") return false;

    const t = s(e.title);
    const d = s(e.description);
    const u = s(e.moodleUrl);
    const loc = s(e.room);

    // ключевые слова (можешь расширить)
    const isDeadline =
      t.includes("due") ||
      t.includes("deadline") ||
      t.includes("assignment") ||
      t.includes("quiz") ||
      t.includes("workshop") ||
      t.includes("turnitin") ||
      d.includes("due") ||
      d.includes("deadline") ||
      d.includes("assignment") ||
      d.includes("submission") ||
      u.includes("mod/assign") ||
      u.includes("mod/quiz") ||
      u.includes("mod/workshop");

    if (/\b[a-z]{1,2}-?\d{3,4}\b/i.test(loc)) return false;
    return isDeadline;
  });
}
